import * as pdfjsLib from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.mjs?url";
import { useState } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const buildPdfCopyHtml = (range: Range) => {
  const container = document.createElement("div");
  container.appendChild(range.cloneContents());
  container.innerHTML = container.innerHTML.replace(/<\/span\s*>\s*<br\b[^>]*\/?>\s*<span\b[^>]*>/g, " ");
  return container;
};

const htmlToText = (el: HTMLElement): string => {
  const clone = el.cloneNode(true) as HTMLElement;
  clone.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
  clone.querySelectorAll("p, div").forEach((block) => block.append("\n"));
  return clone.textContent ?? "";
};

interface PDFWithSelectProps {
  fileUrl: string;
  setSelectedText: (text: string) => void;
  width: number;
}

export const PDFWithSelect: React.FC<PDFWithSelectProps> = ({ fileUrl, setSelectedText, width }) => {
  const [numPages, setNumPages] = useState<number>();

  const handleMouseUp = () => {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return;
    const range = selection.getRangeAt(0);
    const rangeHtml = buildPdfCopyHtml(range);
    setSelectedText(htmlToText(rangeHtml));
  };

  const handleCopy = (e: React.ClipboardEvent<HTMLDivElement>) => {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return;
    const range = selection.getRangeAt(0);
    const rangeHtml = buildPdfCopyHtml(range);
    e.clipboardData.setData("text/html", rangeHtml.innerHTML);
    e.clipboardData.setData("text/plain", htmlToText(rangeHtml));
    e.preventDefault();
  };

  return (
    <div
      className="flex items-center justify-center"
      onMouseUp={handleMouseUp}
      onCopy={handleCopy}
      style={{ userSelect: "text" }}
    >
      <Document file={fileUrl} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
        {numPages &&
          Array.from(new Array(numPages), (_, idx) => <Page key={idx + 1} pageNumber={idx + 1} width={width} />)}
      </Document>
    </div>
  );
};
